const footerLinks = {
  Solutions: [
    { label: 'Payment Gateway', href: '/solutions#gateway' },
    { label: 'Recurring Billing', href: '/solutions#recurring' },
    { label: 'Fraud Prevention', href: '/solutions#fraud' },
    { label: 'POS Integration', href: '/solutions#pos' },
  ],
  Company: [
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'FAQ', href: '/faq' },
  ],
};

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #1a3870 0%, #061e45 100%)' }}>
      <div className="absolute inset-0" />
      <div className="relative z-10">
      {/* Main Footer — desktop */}
      <div className="hidden md:block py-16 px-[75px]">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-2" style={{ paddingRight: '50px' }}>
            <img
              src="/images/logo-white.png"
              alt="Fore Capital"
              className="h-16 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p
              className="text-[#d3b366] text-[11px] uppercase tracking-[0.22em] font-medium mb-4"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              The Infrastructure Behind Growth
            </p>
            <p
              className="text-white/40 text-[15px] leading-relaxed"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              Full transparency. Real-time visibility. Built for how your business actually runs.
            </p>

          </div>

          {/* Company */}
          <div>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.2em] font-medium mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Company
            </p>
            <ul className="flex flex-col gap-3">
              {footerLinks.Company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/55 text-[15px] hover:text-white transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.2em] font-medium mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Solutions
            </p>
            <ul className="flex flex-col gap-3">
              {footerLinks.Solutions.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/55 text-[15px] hover:text-white transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.2em] font-medium mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Get in Touch
            </p>
            <div className="flex flex-col gap-4">
              <a
                href="mailto:contact@forecapitalgrp.com"
                className="text-white/80 hover:text-white transition-colors duration-200 cursor-pointer text-[15px]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                contact@forecapitalgrp.com
              </a>
              <p
                className="text-white/40 text-[15px] leading-relaxed"
                style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
              >
                Austin, TX
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="md:hidden py-10 px-5">
        <div className="flex flex-col items-center gap-6 text-center">
          {/* Logo */}
          <img
            src="/images/logo-white.png"
            alt="Fore Capital"
            className="h-14 w-auto object-contain brightness-0 invert"
          />
          {/* Slogan */}
          <p
            className="text-[#d3b366] text-[11px] uppercase tracking-[0.22em] font-medium"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            The Infrastructure Behind Growth
          </p>
          {/* Body */}
          <p
            className="text-white/40 text-[15px] leading-relaxed"
            style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
          >
            Full transparency. Real-time visibility. Built for how your business actually runs.
          </p>
          {/* Divider */}
          <div className="w-full h-px bg-white/10" />
          {/* Contact */}
          <p
            className="text-[#d3b366] text-[10px] uppercase tracking-[0.2em] font-medium"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Get in Touch
          </p>
          <a
            href="mailto:contact@forecapitalgrp.com"
            className="text-white/80 hover:text-white transition-colors duration-200 cursor-pointer text-[15px]"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            contact@forecapitalgrp.com
          </a>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6 px-8 md:px-[75px]">
        <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-white/30 text-[12px]"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            &copy; {new Date().getFullYear()} Fore Capital, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {[
              { label: 'Privacy Policy', href: '/privacy' },
              { label: 'Terms of Service', href: '/terms' },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-white/35 text-[12px] hover:text-white/70 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
}
